"use client"
import Markdown from "react-markdown"
import { useLayoutEffect } from "react"
import remarkGfm from "remark-gfm"
import styles from "./ai-message.module.css"
import { allowedLink } from "./ai-links"
import { crmMailtoTarget } from "./crm-mailto"
export function AiMessage({ text, onReady, emailLinks = false }: { text: string; onReady?: () => void; emailLinks?: boolean }) {
  useLayoutEffect(() => { onReady?.() }, [text, onReady])
  return <div className={styles.message}><Markdown remarkPlugins={[remarkGfm]} skipHtml components={{
    a: ({ href, children }) => {
      if (emailLinks && href && /^mailto:/i.test(href)) {
        try { crmMailtoTarget(href); return <a href={href}>{children}</a> } catch { return <span>{children}</span> }
      }
      const target = allowedLink(href)
      return target ? <a href={target} target="_blank" rel="noopener noreferrer">{children}</a> : <span>{children}</span>
    },
    img: ({ alt }) => <span>{alt ?? ""}</span>,
    table: ({ children }) => <div className={styles.table}><table>{children}</table></div>,
  }}>{text}</Markdown></div>
}
